<script lang="ts">
	import { contentSlide } from '$lib/animations/ContentTransitions';
	import type { HeaderBlockData } from '$lib/queries/content/HeaderBlockQuery';
	import { SideBar } from '@atoms';
	import DatoAsset from '@atoms/DatoAsset.svelte';
	import Graphic from '@atoms/Graphic.svelte';
	import { Breakpoints, Theme } from '@tools';

	let {
		data,
		index
	}: {
		data: HeaderBlockData;
		index: number;
	} = $props();
	const theme = new Theme(data.colorTheme);
</script>

<section class="block:highlight-block block:large" style={theme.css}>
	{#if index === 0}
		<SideBar title={!data.title} />
	{/if}
	<div class="container" class:left={!data.graphic || data.graphic === 'none'}>
		{#if data.assetWidescreen && Breakpoints.md}
			<DatoAsset data={data.assetWidescreen} lazy={index !== 0} />
		{:else}
			<DatoAsset data={data.asset} lazy={index !== 0} />
		{/if}
		{#if data.title || data.link}
			<div class="cover"></div>
		{/if}
		<Graphic type={data.graphic} />
		{#if data.title || data.link}
			{#if data.title}
				{#if index === 0}
					<h1 class="text:h1" in:contentSlide|global out:contentSlide|global>{data.title}</h1>
				{:else}
					<h2 class="text:h1" in:contentSlide|global out:contentSlide|global>{data.title}</h2>
				{/if}
			{/if}
			{#if !!data.text && Breakpoints.md}
				<p class="text:body-lg" in:contentSlide|global out:contentSlide|global>{data.text}</p>
			{/if}
			{#if data.link}
				<a class="button:inverted" {...data.link} in:contentSlide|global out:contentSlide|global
					>{data.buttonText ?? data.link.title}</a
				>
			{/if}
		{/if}
	</div>
</section>

<style lang="scss">
	section {
		position: relative;
		display: flex;
		align-items: stretch;
		background-color: var(--theme-primary);
		overflow: hidden;
		@include fullBleedBlock;
	}

	.container {
		flex: 1 1 auto;
		position: relative;
		z-index: 2;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		text-align: center;
		gap: $gap4;
		color: $colorBackground;
		background-color: var(--theme-primary);
		aspect-ratio: 1 / #{$ratio1};
		--graphic-color: var(--theme-secondary);
		padding: 0 $gap5;

		@include md {
			gap: $gap5;
			padding: $gap8;
			color: $colorBackground;
			aspect-ratio: #{$ratio3} / 1;

			&.left {
				text-align: left;
				align-items: flex-start;
			}
		}

		:global(.asset) {
			position: absolute;
			top: 0;
			right: 0;
			z-index: 1;
		}
	}

	.cover {
		pointer-events: none;
		position: absolute;
		top: 0;
		left: 0;
		height: 100%;
		width: 100%;
		z-index: 1;
		background-color: rgba(0, 0, 0, 0.4);
		display: block;
	}

	.text\:h1 {
		position: relative;
		z-index: 2;
		text-transform: uppercase;

		@include md {
			max-width: 80vw;
		}
	}

	p {
		position: relative;
		z-index: 2;
		padding-bottom: $gap2;

		@include md {
			max-width: 30em;
		}
	}

	a {
		position: relative;
		z-index: 2;
	}
</style>
